var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.7 9.1h.9a.9.9 0 0 1 .9.9v9H1.9a.9.9 0 0 1-.9-.9v-6.3a2.7 2.7 0 0 1 2.7-2.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3071",
    d: "M3.7 9.55h.9a.45.45 0 0 1 .45.45v8.1a.45.45 0 0 1-.45.45H1.9a.45.45 0 0 1-.45-.45v-6.3A2.25 2.25 0 0 1 3.7 9.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.3 1h15.3a2.7 2.7 0 0 1 2.7 2.7v12.6a2.7 2.7 0 0 1-2.7 2.7h-18V3.7A2.7 2.7 0 0 1 7.3 1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3071",
    d: "M7.3 1.45h15.3a2.25 2.25 0 0 1 2.25 2.25v12.6a2.25 2.25 0 0 1-2.25 2.25H5.5a.45.45 0 0 1-.45-.45V3.7A2.25 2.25 0 0 1 7.3 1.45Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3071",
    strokeLinecap: "round",
    d: "M9.55 6.4h10.8M9.55 10h10.8M9.55 13.6h10.8"
  })));
};
export default SvgNews;